import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import { Block } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { ParagraphCTA as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';

interface ParagraphCTAProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphCTA: React.FC<ParagraphCTAProps> = ({
  entity,
}) => {
  const paragraphEntity = entity.toJS();
  const blockEntity = paragraphEntity.field_cta_block[0].entity;

  return (
    <Block
      entity={Immutable.fromJS(blockEntity)}
    />
  );
};

export default ParagraphCTA;
